import apiClient from '../../../common/functions/api_axios_instance.function';

/**
 * Fetches a system invoice document as a blob and creates a blob URL.
 * @param {string} filePath - Stored file path (e.g. assets/invoices/...)
 * @returns {Promise<string>} Blob URL for preview/download
 */
export const getDocumentBlob = async (filePath) => {
  try {
    const path = String(filePath || '').replace(/^\/+/, '');
    if (!path) {
      throw new Error('File path is required');
    }

    const response = await apiClient.get(
      `/approvalPersonSystemInvoiceManagement/invoice/document/${path}`,
      {
        responseType: 'blob',
      }
    );

    const blob = new Blob([response.data], { type: response.data.type || 'application/pdf' });
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error('Error fetching document blob:', error);
    throw error;
  }
};

/**
 * Revokes a blob URL to free up memory
 * @param {string} blobUrl - The blob URL to revoke
 */
export const revokeBlobUrl = (blobUrl) => {
  if (blobUrl && blobUrl.startsWith('blob:')) {
    URL.revokeObjectURL(blobUrl);
  }
};
